import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { categories } from '@/mocks/manga';

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [searchOpen, setSearchOpen] = useState(false);
  const [searchQuery, setSearchQuery] = useState('');
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 60);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setMobileMenuOpen(false);
    setSearchOpen(false);
  }, [location]);

  const handleSearch = (e: React.FormEvent) => {
    e.preventDefault();
    if (searchQuery.trim()) {
      window.REACT_APP_NAVIGATE(`/category/remen?search=${encodeURIComponent(searchQuery.trim())}`);
      setSearchQuery('');
      setSearchOpen(false);
    }
  };

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled ? 'bg-background-50/95 backdrop-blur-sm border-b border-background-200/70' : 'bg-transparent'
      }`}
    >
      <nav className="w-full px-4 md:px-6">
        <div className="flex items-center justify-between h-16 max-w-screen-2xl mx-auto">
          <Link to="/" className="flex items-center gap-2 whitespace-nowrap cursor-pointer">
            <span className="w-9 h-9 flex items-center justify-center bg-primary-500 text-background-50 rounded-lg">
              <i className="ri-book-open-line text-lg"></i>
            </span>
            <span className="text-xl font-heading text-foreground-950 hidden sm:block">
              亲亲漫画
            </span>
          </Link>

          <div className="hidden md:flex items-center gap-1">
            {categories.map((cat) => (
              <Link
                key={cat.slug}
                to={`/category/${cat.slug}`}
                className="px-4 py-2 text-sm font-medium text-foreground-700 hover:text-primary-500 rounded-lg hover:bg-background-100 transition-colors duration-200 whitespace-nowrap cursor-pointer"
              >
                {cat.name}
              </Link>
            ))}
          </div>

          <div className="hidden md:flex items-center gap-3">
            <button
              onClick={() => setSearchOpen(!searchOpen)}
              className="w-9 h-9 flex items-center justify-center rounded-lg text-foreground-600 hover:text-primary-500 hover:bg-background-100 transition-colors duration-200 cursor-pointer"
              aria-label="搜索"
            >
              <i className="ri-search-line text-lg"></i>
            </button>
            <Link
              to="/about"
              className="px-4 py-2 text-sm font-medium text-foreground-700 hover:text-primary-500 rounded-lg hover:bg-background-100 transition-colors duration-200 whitespace-nowrap cursor-pointer"
            >
              关于我们
            </Link>
          </div>

          <div className="flex md:hidden items-center gap-2">
            <button
              onClick={() => setSearchOpen(!searchOpen)}
              className="w-9 h-9 flex items-center justify-center rounded-lg text-foreground-600 hover:text-primary-500 cursor-pointer"
              aria-label="搜索"
            >
              <i className="ri-search-line text-lg"></i>
            </button>
            <button
              onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
              className="w-9 h-9 flex items-center justify-center rounded-lg text-foreground-600 hover:text-primary-500 cursor-pointer"
              aria-label="菜单"
            >
              <i className={`text-lg ${mobileMenuOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
            </button>
          </div>
        </div>

        {searchOpen && (
          <div className="py-3 border-t border-background-200/70">
            <form onSubmit={handleSearch} className="max-w-screen-2xl mx-auto px-4">
              <div className="relative">
                <i className="ri-search-line absolute left-3 top-1/2 -translate-y-1/2 text-foreground-400 text-sm"></i>
                <input
                  type="text"
                  value={searchQuery}
                  onChange={(e) => setSearchQuery(e.target.value)}
                  placeholder="搜索你喜欢的漫画..."
                  className="w-full pl-10 pr-4 py-2.5 rounded-lg bg-background-100 border border-background-200 text-sm text-foreground-950 placeholder:text-foreground-400 focus:outline-none focus:border-primary-300 focus:ring-2 focus:ring-primary-100 transition-all duration-200"
                />
              </div>
            </form>
          </div>
        )}
      </nav>

      {mobileMenuOpen && (
        <div className="md:hidden bg-background-50 border-t border-background-200/70">
          <div className="px-4 py-3 flex flex-col gap-1">
            {categories.map((cat) => (
              <Link
                key={cat.slug}
                to={`/category/${cat.slug}`}
                className="flex items-center gap-3 px-3 py-2.5 rounded-lg text-sm font-medium text-foreground-700 hover:text-primary-500 hover:bg-background-100 transition-colors duration-200 cursor-pointer"
              >
                <span className="w-7 h-7 flex items-center justify-center">
                  <i className={`${cat.icon} text-base`}></i>
                </span>
                {cat.name}
              </Link>
            ))}
            <Link
              to="/about"
              className="flex items-center gap-3 px-3 py-2.5 rounded-lg text-sm font-medium text-foreground-700 hover:text-primary-500 hover:bg-background-100 transition-colors duration-200 cursor-pointer"
            >
              <span className="w-7 h-7 flex items-center justify-center">
                <i className="ri-information-line text-base"></i>
              </span>
              关于我们
            </Link>
          </div>
        </div>
      )}
    </header>
  );
}